// hooks/notifications.ts
import { useQuery } from '@tanstack/react-query'
import { baseUrl } from 'api/config'
import axios from 'axios'

type CountResponse = { count: number }
type ListResponse = { notifications: any[]; count: number } // count = unreadCount from server

// Badge: unread count only, lightweight
export const useUnreadNotificationsCount = (userId?: string, enabled = true) =>
  useQuery({
    queryKey: ['notifications', 'count', userId],
    queryFn: async (): Promise<number> => {
      const { data } = await axios.get<CountResponse>(`${baseUrl}/aws/notifications/query-user`, {
        params: { userId, mode: 'count', unreadOnly: true },
      })
      return data?.count ?? 0
    },
    enabled: !!userId && enabled,
    staleTime: 5 * 60 * 1000,
    gcTime: 30 * 60 * 1000,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
  })

// Drawer: full list (and you still get unread count for free)
export const useNotificationsByUserId = (userId?: string, enabled = false) =>
  useQuery({
    queryKey: ['notifications', 'list', userId],
    queryFn: async () => {
      const { data } = await axios.get<ListResponse>(
        `${baseUrl}/aws/notifications/query-user`,
        { params: { userId, mode: 'list' } } // or omit mode
      )
      return {
        notifications: data?.notifications ?? [],
        unreadCount: data?.count ?? 0, // server already computed unread
      }
    },
    enabled: !!userId && enabled, // only true when drawer is open
    staleTime: 60 * 1000,
    gcTime: 30 * 60 * 1000,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
  })

// // useSubtasksById.ts
// import { useQuery } from '@tanstack/react-query'
// import { baseUrl } from 'api/config'
// import axios from 'axios'

// export const fetchNotificationsByUserId = async (userId: string) => {
//   console.log('[fetchNotificationsByUserId] userId', userId)
//   const { data } = await axios.get(`${baseUrl}/aws/notifications/query-user`, {
//     params: { userId: userId },
//   })
//   return data || []
// }

// export const useNotificationsByUserId = (userId: string) => {
//   console.log('[useNotificationsByUserId] userId', userId)

//   const { data = {}, isLoading: isNotificationsLoading, isError: isNotificationsError } = useQuery({
//     queryKey: ['notifications', userId],
//     queryFn: () => fetchNotificationsByUserId(userId),
//     enabled: !!userId,
//     staleTime: 1000 * 60 * 5,
//   })

//   const notifications = data.notifications || []

//   return { notifications, isNotificationsLoading, isNotificationsError }
// }
